import {
  type BlocksByColumns,
  type BlockWithCommonSubblocksType,
  type BlockWithoutValuesType,
  type BlockWithRequirementsType,
  type CommonBlockType,
  type InfoBlock,
  type RequirementType,
  BlockTypes,
} from '../../../model/tariffs'
import type {
  TariffBlock,
  TariffBlockWithCommonSubblocks,
  TariffBlockWithoutValues,
  TariffBlockWithRequirements,
  TariffCommonBlock,
  TariffRequirementItem,
} from '../../../repo/tariffs'

export function toBlocksByColumns(blocks: TariffBlock[]): BlocksByColumns {
  // Блоки сверху над колонками
  const top: InfoBlock[] = []
  // Колонки
  const columns: InfoBlock[][] = []

  for (const tariffBlock of blocks) {
    const block = toInfoBlock(tariffBlock)
    const {column} = block

    if (column === undefined) {
      top.push(block)
    } else {
      if (!columns[column]) {
        columns[column] = [block]
      } else {
        columns[column].push(block)
      }
    }
  }

  return {
    top,
    columns: columns.map(column => [...column].sort((a, b) => a.row - b.row)),
  }
}

function toInfoBlock(block: TariffBlock): InfoBlock {
  switch (block.block_type) {
    case 'block_without_values':
      return toBlockWithoutValues(block)

    case 'block_with_common_subblocks':
      return toBlockWithCommonSubblocks(block)

    case 'block_with_requirements':
      return toBlockWithRequirements(block)

    case 'common_block':
      return toCommonBlock(block)
  }
}

function toBlockWithoutValues(block: TariffBlockWithoutValues): BlockWithoutValuesType {
  const {block_id, title, action, column_id, icon, is_collapsed, row_id, subtitle, text_value} = block

  return {
    type: BlockTypes.BLOCK_WITHOUT_VALUES,
    id: block_id,
    row: Number(row_id), // Договорились с бекендом, что row всегда есть. Спеки поправят позже
    title,
    action,
    column: column_id,
    icon,
    mayBeCollapsed: is_collapsed,
    subtitle,
    text: text_value,
  }
}

function toBlockWithRequirements(block: TariffBlockWithRequirements): BlockWithRequirementsType {
  const {block_id, title, column_id, row_id, subtitle, requirements, title_value} = block

  return {
    type: BlockTypes.BLOCK_WITH_REQUIREMENTS,
    id: block_id,
    row: Number(row_id),
    title,
    column: column_id,
    subtitle,
    titleValue: title_value,
    requirements: requirements.map(toRequirement),
  }
}

function toRequirement(item: TariffRequirementItem): RequirementType {
  return {...item}
}

function toBlockWithCommonSubblocks(block: TariffBlockWithCommonSubblocks): BlockWithCommonSubblocksType {
  const {block_id, title, column_id, row_id, subtitle, blocks} = block

  return {
    type: BlockTypes.BLOCK_WITH_COMMON_SUBBLOCKS,
    id: block_id,
    row: Number(row_id),
    title,
    column: column_id,
    subtitle,
    blocks: blocks.map(toCommonBlock),
  }
}

function toCommonBlock(block: TariffCommonBlock): CommonBlockType {
  const {block_id, title, column_id, row_id, subtitle, subblocks} = block

  return {
    type: BlockTypes.COMMON_BLOCK,
    id: block_id,
    row: Number(row_id),
    title,
    column: column_id,
    subtitle,
    subblocks: subblocks.map(toBlockWithRequirements),
  }
}
